var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 6.44772 2.44772 6 3 6H5V12H2V7Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H13C13.5523 8 14 8.44772 14 9V12H11V8Z",
    fill: "#6A84C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 4.44772 6.44772 4 7 4H9C9.55228 4 10 4.44772 10 5V12H6V5Z",
    fill: "#6A84C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardIcon);
export default __webpack_public_path__ + "static/media/leaderboard-icon.45bfcd1237d52bf3fc31c8c3b1c25ffb.svg";
export { ForwardRef as ReactComponent };